import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useFeatureCardStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorBrandBackground2Hover,
    opacity: 0.9,
    ...shorthands.borderRadius('1rem'),
    ...shorthands.padding(tokens.spacingHorizontalM),
    minWidth: '7.5rem',
    minHeight: '8rem',
    flex: '1 1 8.75rem',
    maxWidth: '11.25rem',
    boxSizing: 'border-box',
  },

  /**
   * Figma-aligned floating info card (node 1-1445): row layout with a tinted
   * 48×48 icon chip on the left and a stacked title + description on the
   * right. Soft border + drop shadow, off-white background.
   */
  rootFigma: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground1,
    opacity: 1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    boxShadow: tokens.shadow8,
    ...shorthands.borderRadius('0.5rem'),
    ...shorthands.padding(tokens.spacingHorizontalL),
    minWidth: '17rem',
    maxWidth: '20rem',
    minHeight: '6.625rem',
  },

  figmaTextStack: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXXS,
    flex: '1 1 auto',
    minWidth: 0,
  },

  iconBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    width: '2rem',
    height: '2rem',
    backgroundColor: tokens.colorBrandBackground2,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },

  iconBadgeFigma: {
    alignSelf: 'flex-start',
    // Compensate for the title's first-line leading so the icon badge's top
    // edge visually lines up with the title cap height (not the title text-box
    // top, which sits half a leading line above the visible glyphs).
    marginTop: tokens.spacingVerticalM,
    backgroundColor: 'transparent',
    width: '3rem',
    height: '3rem',
    flexShrink: 0,
    ...shorthands.borderRadius('0.75rem'),
  },

  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '1.125rem',
    height: '1.125rem',
    color: tokens.colorBrandForeground2,
  },

  iconFigma: {
    color: tokens.colorBrandForeground1,
    width: '3rem',
    height: '3rem',
  },

  titleFigma: {
    fontSize: fontScale.body,
    fontWeight: 600,
    lineHeight: '1.43em',
    marginTop: 0,
  },

  descriptionFigma: {
    fontSize: fontScale.caption,
    fontWeight: 400,
    lineHeight: '1.33em',
    marginTop: 0,
  },

  title: {
    fontWeight: 600,
    fontSize: fontScale.caption,
    lineHeight: '1.33em',
    color: tokens.colorNeutralForeground1,
    marginTop: tokens.spacingVerticalXS,
  },

  description: {
    fontWeight: 400,
    fontSize: fontScale.caption,
    lineHeight: '1.33em',
    color: tokens.colorNeutralForeground2,
    marginTop: tokens.spacingVerticalXXS,
  },
});
